import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_template_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  doc_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldClass;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  foreign_ccy: boolean;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  t2t_other_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  t2t_other_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_discount: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom_incl_tax: fromDatatype.NumericDatatypeInterface
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  multi_level_discount_json: fromDatatype.JsonDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.JsonDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;

}

export class bl_fi_generic_doc_template_line_RowClass
  implements bl_fi_generic_doc_template_line_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  doc_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldClass;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  foreign_ccy: boolean;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  t2t_other_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  t2t_other_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_discount: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom_incl_tax: fromDatatype.NumericDatatypeInterface
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  multi_level_discount_json: fromDatatype.JsonDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.JsonDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
